import styled from 'styled-components';
import MotifAccordion from '@ey/motif-react-wrapper/Accordion';

export default styled(MotifAccordion)`
	margin-top: var(--px-20) !important;
	.motif-accordion-expand-icon {
		opacity: 1;
	}
	.motif-accordion-collapse-icon {
		opacity: 0;
	}
	&.motif-accordion-content-visible {
		.motif-accordion-expand-icon {
			opacity: 0;
		}
		.motif-accordion-collapse-icon {
			opacity: 1;
		}
	}
`;
